import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import type { WorkerFilters } from "@/domains/workers/types";
import { WORKERS_QUERY } from "@/graphql/workers";

export interface UseWorkersQueryOptions {
  salonId: string | undefined;
  filters?: WorkerFilters;
}

export const useWorkersQuery = ({ salonId, filters = {} }: UseWorkersQueryOptions) => {
  const queryResult = useQuery(WORKERS_QUERY, {
    variables: {
      salonId: salonId ?? "",
      filters: {
        page: 1,
        limit: 50,
        sortBy: "createdAt",
        sortOrder: "desc",
        isActive: true,
        ...filters,
      },
    },
    skip: !salonId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
    returnPartialData: true,
    pollInterval: 60000,
  });

  const hasMore = useMemo(() => {
    return queryResult.data?.workers?.pagination?.hasNext || false;
  }, [queryResult.data?.workers?.pagination?.hasNext]);

  return {
    ...queryResult,
    hasMore,
  };
};
